import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/TextAreaInput' /* webpackChunkName: "TextAreaInput" */),
    import(
      './viewer/TextAreaInput.controller' /* webpackChunkName: "TextAreaInput" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('TextAreaInput', UiTypes),
};

export default entry;
